import { LABEL_NO_MESSAGE_REQUIRED } from '../types/product'

export const replacePlaceholderWithName = (
  message: string,
  name?: string
): string => {
  return message.includes('{name}') && name && name.length
    ? message.replace(/{name}/, name)
    : message && message.replace(/ {name}/, '')
}

export const createName = (
  isGift: boolean,
  name?: string
): string | undefined => (isGift ? name : undefined)

export const createMessage = (
  isGift: boolean,
  message?: string,
  toName?: string
): string | undefined => {
  return isGift && message && message !== LABEL_NO_MESSAGE_REQUIRED
    ? replacePlaceholderWithName(message, toName)
    : undefined
}

export const replacedMessage = (
  personaliseMessage?: string,
  personaliseToName?: string
): { personaliseMessage: string } | undefined =>
  personaliseMessage
    ? {
        personaliseMessage: replacePlaceholderWithName(
          personaliseMessage,
          personaliseToName
        ),
      }
    : undefined
